import { Tooltip } from 'flowbite';
import { QUOTE_HIGHLIGHT_TOOLTIP_ID } from '../../ArticleBodyRenderer/constants';

class ArticleHighlightTooltip extends Tooltip {
  _setupClickOutsideListener() {
    this._clickOutsideEventListener = (ev: MouseEvent) => {
      this._handleClickOutside(ev, this._targetEl);
    };
    document.body.addEventListener('mousedown', this._clickOutsideEventListener, true);
  }

  _handleClickOutside(ev: Event, targetEl: HTMLElement) {
    const clickedEl = ev.target as Node;
    if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && this.isVisible()) {
      this.hide();
    }
  }
}

export const articleHighlightTooltipFactory = () => {
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);

  const $tooltip = document.getElementById(QUOTE_HIGHLIGHT_TOOLTIP_ID);
  /**
   *
   * using range as HTMLElement
   * this is hack but thanks to that we can use nice flowbite tooltip
   * some updates related to hiding this tooltip were required
   * that's why we create our own ArticleHighlightTooltip class
   *
   */
  const $tooltipTrigger = range.cloneRange();
  if (!$tooltip || !$tooltipTrigger) {
    return;
  }

  const options = {
    placement: 'top',
    triggerType: 'none',
  };
  const instanceOptions = {
    id: QUOTE_HIGHLIGHT_TOOLTIP_ID,
    override: true,
  };

  return new ArticleHighlightTooltip($tooltip, $tooltipTrigger, options, instanceOptions);
};
